import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { grayLight20, fontSize3XSmall, fontWeightBold } from '../../constants/principles'

import { QuestionUtils } from '../../utils/siteUtils'
import * as QuestionsTypes from '../generic/questions'
import { FlexDiv } from '../generic/Basics'
import ExamplesModal from '../generic/modals/ExamplesModal'
import { ModalContentNormal } from '../generic/Basics.js'

import Examples from './Examples/index'

export default ({
  showModal = {},
  setShowModal,
  saveQuestionResponse,
  getQuestionResponse,
  anyAnswered,
  saveQuestionResponseComment,
  getQuestionResponseComment,
  saveQuestionResponseInteger,
  getQuestionResponseInteger,
  conditionQuestions,
  globalState,
  updateGlobalState,
  pageName,
  isDesktop,
}) => {
  const questions =
    showModal &&
    showModal.name &&
    conditionQuestions &&
    QuestionUtils.getAssociatedQuestions(conditionQuestions, QuestionUtils.translateName(showModal.name), showModal.subsectionCode).map(question => ({ ...question, QuestionType: QuestionsTypes[question.questionType] }))
  const anyTrue = questions && anyAnswered(questions)
  showModal.onChange && showModal.onChange(anyTrue)
  const name = showModal && showModal.name && showModal.name.toLowerCase().split(' ')[0]
  const examples = Examples[name] || (Examples[name] === null ? null : Examples[pageName])

  const title = !globalState.showExamples ? questions && questions[0] && questions[0].itemHeader : examples && examples.title
  const subtitle = !globalState.showExamples && questions && questions[0] && questions[0].itemDescription
  const showExampleLink = examples && questions && questions[0] && (!examples.exclude || !examples.exclude.includes(questions[0].itemHeader))

  return (
    <ExamplesModal
      name={showModal && showModal.name}
      title={title}
      subtitle={subtitle}
      onClick={() => {
        if (globalState.showExamples) {
          updateGlobalState({ showExamples: false })
        } else {
          showModal.onChange && showModal.onChange(anyTrue)
          setShowModal(false)
        }
      }}
      informational={globalState.showExamples}
      showExamples={globalState.showExamples}
      updateGlobalState={updateGlobalState}
      showExampleLink={showExampleLink}>
      <ModalContentCondition addSpace={globalState.showExamples}>
        {!globalState.showExamples
          ? questions &&
            questions.map((question, i) => (
              <QuestionDiv key={i}>
                <question.QuestionType {...{ getQuestionResponse, saveQuestionResponse, saveQuestionResponseComment, getQuestionResponseComment, saveQuestionResponseInteger, getQuestionResponseInteger, isDesktop }} question={{ ...question }} />
              </QuestionDiv>
            ))
          : examples &&
            examples.content.map((item, i) => (
              <Fragment key={i}>
                <BoldP> {item.title}</BoldP>
                <SubText>{item.text}</SubText>
                {item.src && <StyledImg src={item.src} alt={`Example ${item.title}`} />}
              </Fragment>
            ))}
      </ModalContentCondition>
    </ExamplesModal>
  )
}

const BoldP = styled.p`
  margin-bottom: 8px;
  font-weight: ${fontWeightBold};
`
const SubText = styled.div`
  margin-top: 0px;
  font-size: ${fontSize3XSmall};
  margin-bottom: 8px;
`
const ModalContentCondition = styled(ModalContentNormal)`
  margin-top: 8px;
  overflow-x: hidden;
`
const QuestionDiv = styled(FlexDiv)`
  padding-top: 32px;
  padding-bottom: 32px;
  width: 100%;
  border-bottom: 1px solid ${grayLight20};
`

const StyledImg = styled.img`
  max-width: 250px;
`
